























































































import {
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { MemberTypeOption } from '@front-app/modules/group/components/admin/addMembers/addMembers';
import { Size } from '@front-app/components/constants';
import { Routes } from '@front-app/constants/routes';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import TrSnackbar from '@front-app/components/Snackbar.vue';

export default defineComponent({
	components: {
		CtaButton,
		SimpleCard,
		TrSnackbar,
		SuccessCard,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		selectedRole: {
			type: String as PropType<MemberTypeOption>,
			required: true,
		},
		numUsersAdded: {
			type: Number,
			required: true,
		},
	},
	setup(props, ctx) {
		// Copy group link
		const showCopyLinkConfirmation = ref(false);
		const copyGroupUrl = () => {
			const route = ctx.root.$router.resolve({
				name: Routes.GROUP,
				params: {
					groupId: props.groupId,
				},
			});
			const groupUrl = new URL(route.href, window.location.href).href;
			navigator.clipboard.writeText(groupUrl);
			showCopyLinkConfirmation.value = true;
			setTimeout(() => {
				showCopyLinkConfirmation.value = false;
			}, 5000);
		};
		// END Copy group link

		return {
			UserRole,
			// Copy group link
			copyGroupUrl,
			showCopyLinkConfirmation,
			// Util
			ButtonPalettes,
			Size,
		};
	},
});
